import {createAction, props} from '@ngrx/store';
import {CategoryTreeResponse} from '@app/marketplace/categories/_models/category.interface';

export const GET_CATEGORY_TREE = '[CATEGORY-TREE] Get category tree';
export const CATEGORY_TREE_LOADED = 'CATEGORY-TREE] Category tree loaded';
export const UPDATE_PARENT_CATEGORY = '[CATEGORY-TREE] Update parent category';
export const CATEGORY_TREE_FAILURE = '[CATEGORY-TREE] Category tree failure';
export const CANCEL_CATEGORY_TREE_REQUEST = '[CATEGORY-TREE] Cancel category tree request';

export const GetCategoryTree = createAction(GET_CATEGORY_TREE);
export const CategoryTreeLoaded = createAction(CATEGORY_TREE_LOADED,
  props<{data: CategoryTreeResponse}>());
export const UpdateParentCategory = createAction(UPDATE_PARENT_CATEGORY,
  props<{parentCategory: string}>());
export const CancelRequestCategoryTree = createAction(CANCEL_CATEGORY_TREE_REQUEST);
export const CategoryTreeFailure = createAction(CATEGORY_TREE_FAILURE);


